<template>
  <div>
    <base-nav
            v-model="showMenu"
            class="navbar-absolute top-navbar"
            type="white"
            :transparent="true"
    >
        <notifications></notifications>
      <div slot="brand" class="navbar-wrapper">
        <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
        <div
                class="navbar-toggle d-inline"
                :class="{ toggled: $sidebar.showSidebar }"
        >
          <button type="button" class="navbar-toggler" @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="navbar-brand" href="#">{{ routeName }}</a>
      </div>
      <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
        <div class="search-bar input-group" >
          <!--
            <input type="text" class="form-control" placeholder="Search...">
            <div class="input-group-addon"><i class="tim-icons icon-zoom-split"></i></div>
          -->
          <!--
            С обводкой
          <base-button simple >
            <a class="navbar-brand">Выйти</a>
          </base-button>
          -->
          <!-- без обводки -->
          <button
                  class="btn btn-link"

          >
            <a class="navbar-brand" @click="logout()">Выйти</a>
          </button>
          <!-- You can choose types of search input -->
        </div>
      </ul>

    </base-nav>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions';
  import { BaseNav, Modal } from '@/components';
  import SidebarToggleButton from '../Layout/SidebarToggleButton';

  export default {
    components: {
      SidebarToggleButton,
      CollapseTransition,
      BaseNav,
      Modal
    },
    computed: {
      routeName() {
        const { name } = this.$route;
        return this.capitalizeFirstLetter(name);
      },
      isRTL() {
        return this.$rtl.isRTL;
      }
    },
    data() {
      return {
        activeNotifications: true,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: ''
      };
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      async logout(){
        localStorage.removeItem('token');
        localStorage.removeItem('CurrentRelease');
        localStorage.removeItem('getCurrentTrack');
        localStorage.removeItem('currentReleases');
          localStorage.clear('token')
        await this.$store.dispatch('EMPTY_TOKEN');
        this.$router.push('/login');
      }
    }
  };
</script>
<style scoped>
  .top-navbar {
    top: 0px;
  }
</style>
